module.exports = __webpack_public_path__ + "462aacad88147d9872dba22cf5e3d307.png";